export default ({ content, onSelect, onReset }) => {
    return (
        <div className="select-dropdown__content2">
            <div className="select-dropdown__item2" onClick={onReset}>Reset</div>

            { content.map((item, index) => {
                return (
                    <div key={index} className="select-dropdown__item2" onClick={() => onSelect(item)}>{ item.option }</div>
                )
            })}
        </div>
    )
}
